import React from 'react';
// import ReactSeedApp from './components/app/ReactSeedApp';
import rafflesiaAppConfig from './rafflesia-app/app/rafflesia-app-config';
import RafflesiaApp from './rafflesia-app/app/RafflesiaApp';

const App = () => <RafflesiaApp appConfig={rafflesiaAppConfig} />;

export default App;
